import moment from "moment";

export const calculateTotalDays = (fromdate, todate) => {
  if (fromdate && todate) {
    const start = moment(fromdate, "DD-MM-YYYY");
    const end = moment(todate, "DD-MM-YYYY");
    return end.diff(start, "days");
  }
  return 0;
};
